import React from 'react';
import ReactLogo from 'assets/img/icono_happ_fav.svg'
import '../../assets/css/LoadingSpinner.css';

export const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner">
        <img
          src={ReactLogo}
          alt="Loading..."
          className="rotating-svg"
        />
      </div>
    </div>
  );
};